export function getErrorMessageFromException(exception) {
    let message = "";
    if (exception.response.data.length) {
        for (let i = 0; i < exception.response.data.length; i++) {
            if (i == 0) {
                message += exception.response.data[i].errorMessage;
            } else {
                if (
                    !message.toLowerCase().includes(exception.response.data[i].errorMessage.toLowerCase())
                )
                    message += " and " + exception.response.data[i].errorMessage.toLowerCase();
            }
        }
    } else {
        message = exception.response.data.errorMessage;
    }
    return message;
}
export function getErrorMessageFromValidation(items) {
    let message = items[0].msg;
    if (items.length > 1) {
        for (let i = 1; i < items.length; i++) {
            if (!message.toLowerCase().includes(items[i].msg.toLowerCase()))
                message += " and " + items[i].msg.toLowerCase();
        }
    }
    return message;
}
